import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class VendorsService {
  constructor() {}

  fetchVendorById = (vendorId: any) => {
    return vendorId;
  };
}
